import { type ComponentPropsWithoutRef, type ReactElement } from 'react'

interface AllyTextProps extends ComponentPropsWithoutRef<'span'> {
  text: string
}

export function AllyText(props: AllyTextProps): ReactElement {
  const { text, ...rest } = props

  return (
    <span className="visually-hidden" {...rest}>
      {text}
    </span>
  )
}
